var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep1Img(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416,
    height: 282,
    viewBox: "0 0 400 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_22492_10099)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22492_10099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8501 30.8501C20.8501 25.3272 25.3273 20.8501 30.8501 20.8501H403.85V269.8H20.8501V30.8501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.8501,
    y: 116.85,
    width: 338.936,
    height: 90,
    rx: 4.03489,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.8501,
    y: 128.85,
    width: 19.3675,
    height: 19.3675,
    rx: 9.68373,
    fill: "#42296E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8807 135.439V142.482H62.3917V136.853H62.3504L60.7376 137.864V136.543L62.4811 135.439H63.8807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.2871,
    y: 128.85,
    width: 95.0551,
    height: 7.00406,
    rx: 3.50203,
    fill: "#CACDDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.2871,
    y: 139.889,
    width: 73.0423,
    height: 7.00406,
    rx: 3.50203,
    fill: "#E4E6F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.2871,
    y: 150.928,
    width: 52.0301,
    height: 7.00406,
    rx: 3.50203,
    fill: "#E4E6F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9834 178.283H138.66C139.41 178.283 140.017 178.891 140.018 179.64V190.409C140.018 191.158 139.41 191.766 138.66 191.766H81.9834C81.2339 191.766 80.626 191.158 80.626 190.409V179.64C80.6262 178.891 81.2341 178.283 81.9834 178.283Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9834 178.283H138.66C139.41 178.283 140.017 178.891 140.018 179.64V190.409C140.018 191.158 139.41 191.766 138.66 191.766H81.9834C81.2339 191.766 80.626 191.158 80.626 190.409V179.64C80.6262 178.891 81.2341 178.283 81.9834 178.283Z",
    stroke: "#42296E",
    strokeWidth: 0.678685
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7143 189.025H85.0866V181.271H87.7673C88.5372 181.271 89.1985 181.426 89.7513 181.736C90.3066 182.044 90.7332 182.487 91.0311 183.065C91.3289 183.643 91.4779 184.335 91.4779 185.14C91.4779 185.948 91.3277 186.642 91.0273 187.223C90.7294 187.803 90.2991 188.249 89.7362 188.559C89.1758 188.87 88.5018 189.025 87.7143 189.025ZM86.4913 187.81H87.6461C88.1863 187.81 88.6369 187.711 88.9979 187.514C89.3588 187.315 89.6302 187.018 89.8119 186.624C89.9936 186.228 90.0845 185.733 90.0845 185.14C90.0845 184.547 89.9936 184.055 89.8119 183.664C89.6302 183.27 89.3613 182.976 89.0054 182.781C88.652 182.584 88.2128 182.486 87.6878 182.486H86.4913V187.81ZM95.2888 189.138C94.7208 189.138 94.2286 189.014 93.8121 188.764C93.3956 188.514 93.0725 188.164 92.8428 187.715C92.6157 187.266 92.5021 186.741 92.5021 186.14C92.5021 185.539 92.6157 185.013 92.8428 184.561C93.0725 184.109 93.3956 183.758 93.8121 183.508C94.2286 183.258 94.7208 183.133 95.2888 183.133C95.8567 183.133 96.3489 183.258 96.7654 183.508C97.1819 183.758 97.5038 184.109 97.7309 184.561C97.9606 185.013 98.0755 185.539 98.0755 186.14C98.0755 186.741 97.9606 187.266 97.7309 187.715C97.5038 188.164 97.1819 188.514 96.7654 188.764C96.3489 189.014 95.8567 189.138 95.2888 189.138ZM95.2964 188.04C95.6043 188.04 95.8618 187.956 96.0688 187.787C96.2757 187.615 96.4297 187.385 96.5307 187.098C96.6342 186.81 96.6859 186.489 96.6859 186.136C96.6859 185.78 96.6342 185.458 96.5307 185.17C96.4297 184.88 96.2757 184.649 96.0688 184.478C95.8618 184.306 95.6043 184.22 95.2964 184.22C94.9808 184.22 94.7183 184.306 94.5088 184.478C94.3018 184.649 94.1466 184.88 94.0431 185.17C93.9421 185.458 93.8916 185.78 93.8916 186.136C93.8916 186.489 93.9421 186.81 94.0431 187.098C94.1466 187.385 94.3018 187.615 94.5088 187.787C94.7183 187.956 94.9808 188.04 95.2964 188.04ZM100.272 189.025L98.6292 183.209H100.026L101.049 187.298H101.102L102.147 183.209H103.529L104.574 187.276H104.631L105.638 183.209H107.039L105.392 189.025H103.964L102.874 185.095H102.794L101.704 189.025H100.272ZM109.366 185.617V189.025H107.996V183.209H109.306V184.197H109.374C109.508 183.872 109.721 183.613 110.014 183.421C110.309 183.229 110.674 183.133 111.108 183.133C111.509 183.133 111.859 183.219 112.157 183.391C112.457 183.563 112.689 183.811 112.853 184.137C113.02 184.462 113.102 184.857 113.1 185.322V189.025H111.729V185.534C111.729 185.145 111.628 184.841 111.426 184.621C111.227 184.402 110.95 184.292 110.597 184.292C110.357 184.292 110.144 184.345 109.957 184.451C109.773 184.555 109.627 184.705 109.521 184.902C109.418 185.099 109.366 185.337 109.366 185.617ZM115.863 181.271V189.025H114.493V181.271H115.863ZM119.81 189.138C119.242 189.138 118.75 189.014 118.333 188.764C117.917 188.514 117.594 188.164 117.364 187.715C117.137 187.266 117.023 186.741 117.023 186.14C117.023 185.539 117.137 185.013 117.364 184.561C117.594 184.109 117.917 183.758 118.333 183.508C118.75 183.258 119.242 183.133 119.81 183.133C120.378 183.133 120.87 183.258 121.286 183.508C121.703 183.758 122.025 184.109 122.252 184.561C122.482 185.013 122.596 185.539 122.596 186.14C122.596 186.741 122.482 187.266 122.252 187.715C122.025 188.164 121.703 188.514 121.286 188.764C120.87 189.014 120.378 189.138 119.81 189.138ZM119.817 188.04C120.125 188.04 120.383 187.956 120.59 187.787C120.797 187.615 120.951 187.385 121.052 187.098C121.155 186.81 121.207 186.489 121.207 186.136C121.207 185.78 121.155 185.458 121.052 185.17C120.951 184.88 120.797 184.649 120.59 184.478C120.383 184.306 120.125 184.22 119.817 184.22C119.502 184.22 119.239 184.306 119.03 184.478C118.823 184.649 118.668 184.88 118.564 185.17C118.463 185.458 118.413 185.78 118.413 186.136C118.413 186.489 118.463 186.81 118.564 187.098C118.668 187.385 118.823 187.615 119.03 187.787C119.239 187.956 119.502 188.04 119.817 188.04ZM125.433 189.142C125.065 189.142 124.733 189.077 124.438 188.945C124.145 188.812 123.913 188.615 123.741 188.355C123.572 188.095 123.487 187.774 123.487 187.393C123.487 187.065 123.548 186.794 123.669 186.579C123.79 186.364 123.955 186.193 124.165 186.064C124.374 185.935 124.61 185.838 124.873 185.772C125.138 185.704 125.412 185.655 125.695 185.625C126.035 185.589 126.312 185.558 126.524 185.53C126.736 185.5 126.89 185.454 126.986 185.394C127.084 185.331 127.133 185.234 127.133 185.102V185.08C127.133 184.794 127.049 184.573 126.88 184.417C126.711 184.26 126.467 184.182 126.149 184.182C125.813 184.182 125.547 184.255 125.35 184.402C125.156 184.548 125.024 184.721 124.956 184.921L123.677 184.739C123.777 184.385 123.944 184.09 124.176 183.853C124.409 183.613 124.693 183.434 125.028 183.315C125.364 183.194 125.735 183.133 126.141 183.133C126.422 183.133 126.701 183.166 126.978 183.232C127.256 183.298 127.51 183.406 127.739 183.557C127.969 183.706 128.153 183.91 128.292 184.167C128.433 184.425 128.504 184.746 128.504 185.133V189.025H127.186V188.226H127.141C127.058 188.388 126.94 188.539 126.789 188.68C126.64 188.819 126.452 188.932 126.225 189.017C126 189.101 125.736 189.142 125.433 189.142ZM125.789 188.135C126.064 188.135 126.303 188.081 126.505 187.972C126.707 187.861 126.862 187.715 126.971 187.533C127.082 187.351 127.137 187.153 127.137 186.939V186.253C127.094 186.289 127.021 186.321 126.918 186.352C126.817 186.382 126.703 186.409 126.577 186.431C126.451 186.454 126.326 186.474 126.202 186.492C126.078 186.51 125.971 186.525 125.88 186.537C125.676 186.565 125.493 186.611 125.331 186.674C125.17 186.737 125.042 186.825 124.949 186.939C124.855 187.05 124.809 187.194 124.809 187.37C124.809 187.623 124.901 187.813 125.085 187.942C125.269 188.071 125.504 188.135 125.789 188.135ZM132.04 189.127C131.584 189.127 131.175 189.01 130.814 188.775C130.453 188.54 130.167 188.199 129.958 187.753C129.748 187.306 129.644 186.763 129.644 186.125C129.644 185.478 129.75 184.933 129.962 184.489C130.176 184.042 130.465 183.705 130.829 183.478C131.192 183.248 131.597 183.133 132.044 183.133C132.385 183.133 132.665 183.191 132.885 183.308C133.104 183.421 133.279 183.559 133.407 183.72C133.536 183.879 133.636 184.03 133.706 184.171H133.763V181.271H135.138V189.025H133.79V188.109H133.706C133.636 188.25 133.534 188.4 133.4 188.559C133.266 188.716 133.089 188.849 132.87 188.961C132.65 189.072 132.374 189.127 132.04 189.127ZM132.423 188.003C132.713 188.003 132.961 187.924 133.165 187.768C133.369 187.609 133.525 187.388 133.631 187.105C133.737 186.823 133.79 186.493 133.79 186.117C133.79 185.741 133.737 185.414 133.631 185.136C133.527 184.859 133.373 184.643 133.169 184.489C132.967 184.335 132.718 184.258 132.423 184.258C132.117 184.258 131.862 184.337 131.658 184.496C131.454 184.656 131.3 184.875 131.196 185.155C131.093 185.435 131.041 185.756 131.041 186.117C131.041 186.481 131.093 186.805 131.196 187.09C131.302 187.373 131.457 187.596 131.662 187.76C131.869 187.922 132.122 188.003 132.423 188.003Z",
    fill: "#75698E"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_22492_10099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.166 197.494C141.102 197.43 141.054 197.351 141.027 197.264C141 197.177 140.995 197.085 141.012 196.996C141.029 196.906 141.068 196.823 141.124 196.752C141.181 196.68 141.254 196.624 141.338 196.588L144.573 195.346C144.675 195.3 144.76 195.224 144.818 195.129C144.877 195.033 144.905 194.923 144.9 194.811C144.894 194.7 144.856 194.593 144.788 194.503C144.721 194.414 144.629 194.347 144.524 194.311L133.365 190.667C133.268 190.637 133.165 190.634 133.066 190.659C132.968 190.683 132.878 190.734 132.806 190.805C132.735 190.877 132.684 190.967 132.659 191.065C132.635 191.164 132.638 191.267 132.668 191.364L136.309 202.525C136.346 202.63 136.413 202.723 136.502 202.79C136.591 202.857 136.699 202.895 136.81 202.901C136.922 202.906 137.032 202.878 137.128 202.82C137.223 202.761 137.299 202.676 137.345 202.574L138.587 199.339C138.623 199.255 138.679 199.182 138.75 199.125C138.821 199.069 138.905 199.03 138.995 199.013C139.084 198.996 139.176 199.002 139.263 199.028C139.35 199.055 139.429 199.103 139.493 199.167L143.07 202.744C143.175 202.849 143.316 202.908 143.464 202.908C143.612 202.908 143.754 202.849 143.859 202.744L144.743 201.862C144.848 201.757 144.906 201.615 144.906 201.468C144.906 201.32 144.848 201.178 144.743 201.073L141.166 197.494Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.956044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_22492_10099)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.8501,
    y: 216.85,
    width: 338.936,
    height: 90,
    rx: 4.02568,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.8999,
    y: 238.187,
    width: 19.3233,
    height: 19.3233,
    rx: 9.66163,
    fill: "#42296E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.369 251.809V250.739L62.8702 248.423C63.0829 248.217 63.2613 248.032 63.4054 247.867C63.5518 247.702 63.6627 247.541 63.7382 247.383C63.8137 247.223 63.8514 247.05 63.8514 246.865C63.8514 246.659 63.8045 246.482 63.7108 246.333C63.617 246.182 63.4889 246.067 63.3265 245.987C63.1641 245.904 62.98 245.863 62.7741 245.863C62.5591 245.863 62.3715 245.907 62.2114 245.994C62.0513 246.08 61.9278 246.205 61.8409 246.368C61.754 246.53 61.7105 246.723 61.7105 246.947H60.3004C60.3004 246.488 60.4044 246.089 60.6126 245.75C60.8207 245.411 61.1124 245.15 61.4875 244.964C61.8626 244.779 62.2949 244.686 62.7844 244.686C63.2876 244.686 63.7256 244.776 64.0985 244.954C64.4736 245.13 64.7652 245.375 64.9734 245.688C65.1815 246.002 65.2856 246.361 65.2856 246.766C65.2856 247.031 65.233 247.293 65.1277 247.551C65.0248 247.81 64.8407 248.097 64.5754 248.412C64.31 248.726 63.9361 249.102 63.4534 249.541L62.4276 250.546V250.595H65.3782V251.809H60.369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.2744,
    y: 238.187,
    width: 94.8382,
    height: 6.98808,
    rx: 3.49404,
    fill: "#CACDDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.2744,
    y: 249.201,
    width: 72.8756,
    height: 6.98808,
    rx: 3.49404,
    fill: "#E4E6F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.2744,
    y: 260.214,
    width: 51.9114,
    height: 6.98808,
    rx: 3.49404,
    fill: "#E4E6F0"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 136.94,
    y: 103.738,
    width: 73.0423,
    height: 0.484527,
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.98,
    y: 85.5913,
    width: 46.9624,
    height: 13.0919,
    rx: 2,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.982,
    y: 102.035,
    width: 73.0423,
    height: 2.18765,
    fill: "#D8D9DB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.757,
    y: 85.5913,
    width: 46.9624,
    height: 13.0919,
    rx: 2,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.8501,
    y: 20.8491,
    width: 383.921,
    height: 24.8582,
    fill: "#CEDFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2202 36.5911C88.2202 32.0537 91.8985 28.3755 96.4358 28.3755H157.341C161.878 28.3755 165.557 32.0537 165.557 36.5911V48.6303H88.2202V36.5911Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.2342,
    y: 54.0223,
    width: 286.232,
    height: 17.2318,
    rx: 8.61592,
    stroke: "#CDCDCD",
    strokeWidth: 0.768158
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3789 37.8247C36.6215 38.3308 35.7326 38.6008 34.8218 38.6008C33.6012 38.6008 32.4302 38.1158 31.5668 37.2525C30.7034 36.3892 30.2183 35.2184 30.2183 33.9972C30.2183 33.0866 30.4883 32.197 30.9944 31.4398C31.5006 30.6826 32.2196 30.093 33.0604 29.7441C33.9012 29.396 34.8271 29.305 35.7198 29.4824C36.6125 29.6599 37.433 30.0983 38.0768 30.742C38.7206 31.3857 39.1591 32.2061 39.3366 33.0994C39.5141 33.9927 39.4231 34.9176 39.0749 35.7591C38.7266 36.6005 38.1362 37.3187 37.3789 37.8247Z",
    fill: "#FF6058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1899 37.8248C50.4333 38.3308 49.5429 38.6008 48.6328 38.6008C48.0282 38.6008 47.4302 38.482 46.8714 38.2504C46.3134 38.0188 45.805 37.6796 45.3778 37.2525C44.9506 36.8254 44.6114 36.3178 44.3798 35.7591C44.1481 35.2004 44.0293 34.6019 44.0293 33.9973C44.0293 33.0867 44.2993 32.1972 44.8055 31.4399C45.3116 30.6827 46.0299 30.0924 46.8714 29.7443C47.7123 29.3954 48.6381 29.3051 49.5308 29.4826C50.4236 29.6601 51.2441 30.0985 51.8879 30.7421C52.5317 31.3858 52.9701 32.2069 53.1476 33.0995C53.3251 33.9928 53.2341 34.917 52.8859 35.7584C52.5377 36.5998 51.9473 37.3187 51.1899 37.8248Z",
    fill: "#FFBD2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0007 37.8247C64.2441 38.3308 63.3544 38.6008 62.4436 38.6008C61.839 38.6008 61.2403 38.482 60.6815 38.2504C60.1227 38.0188 59.615 37.6796 59.1878 37.2525C58.7607 36.8254 58.4215 36.3178 58.1898 35.7591C57.9582 35.2004 57.8394 34.6018 57.8394 33.9972C57.8394 33.0866 58.1094 32.197 58.6155 31.4398C59.1217 30.6826 59.8407 30.0923 60.6815 29.7441C61.5223 29.396 62.4482 29.305 63.3409 29.4824C64.2336 29.6599 65.0541 30.0983 65.6979 30.742C66.3417 31.3857 66.7802 32.2061 66.9577 33.0986C67.1352 33.992 67.0442 34.9169 66.6959 35.7583C66.3477 36.5998 65.7581 37.3187 65.0007 37.8247Z",
    fill: "#27C940"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_22492_10099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.847 59.5563C390.414 59.5563 390.874 59.0966 390.874 58.5294C390.874 57.9622 390.414 57.5024 389.847 57.5024C389.28 57.5024 388.82 57.9622 388.82 58.5294C388.82 59.0966 389.28 59.5563 389.847 59.5563Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.847 63.6638C390.414 63.6638 390.874 63.204 390.874 62.6368C390.874 62.0696 390.414 61.6099 389.847 61.6099C389.28 61.6099 388.82 62.0696 388.82 62.6368C388.82 63.204 389.28 63.6638 389.847 63.6638Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.847 67.7722C390.414 67.7722 390.874 67.3124 390.874 66.7452C390.874 66.178 390.414 65.7183 389.847 65.7183C389.28 65.7183 388.82 66.178 388.82 66.7452C388.82 67.3124 389.28 67.7722 389.847 67.7722Z",
    fill: "#ACACAC"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 112.158,
    y: 35.8394,
    width: 46.0337,
    height: 4.60337,
    rx: 2.30168,
    fill: "#EEECF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.4272,
    y: 33.9976,
    width: 8.77895,
    height: 8.77895,
    rx: 1.09737,
    fill: "#EEECF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.85,
    y: 49.8501,
    width: 27.576,
    height: 27.576,
    rx: 13.788,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_22492_10099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.638 64.6916V57.3188",
    stroke: "#676767",
    strokeWidth: 1.149,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.431 64.6909V68.9039H354.845V64.6909",
    stroke: "#676767",
    strokeWidth: 1.149,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.271 62.0581L360.638 64.6912L358.004 62.0581",
    stroke: "#676767",
    strokeWidth: 1.149,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_22492_10099",
    x: 0.000102997,
    y: 0.000102997,
    width: 415.921,
    height: 281.871,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.38947,
    dy: -4.38947
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.23026
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.317647 0 0 0 0 0.317647 0 0 0 0 0.317647 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22492_10099"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22492_10099",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_22492_10099",
    x: 43.2398,
    y: 215.24,
    width: 342.157,
    height: 93.2205,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.805136
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22492_10099"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22492_10099",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22492_10099"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8501 30.8501C20.8501 25.3272 25.3273 20.8501 30.8501 20.8501H403.85V269.8H20.8501V30.8501Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_22492_10099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.8462,
    height: 17.8462,
    fill: "white",
    transform: "translate(129.85 187.85)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_22492_10099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.4312,
    height: 16.4312,
    fill: "white",
    transform: "translate(381.631 54.4224)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_22492_10099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.852,
    height: 16.852,
    fill: "white",
    transform: "translate(352.212 55.2124)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1Img);
export default __webpack_public_path__ + "static/media/step_1_img.417736d00ae728d4e55c922c1fa0abf1.svg";
export { ForwardRef as ReactComponent };